import {useEffect} from '@wordpress/element';
import {Elements, PaymentElement} from "@stripe/react-stripe-js";
import {useSelect} from '@wordpress/data';
import {CART_STORE_KEY} from '@woocommerce/block-data';
import {registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import {checkoutEvents} from '@woocommerce/blocks-checkout-events';
import {useLinkIcon, useLink} from "./hooks";
import {getSettings, initStripe} from "../util";
import ErrorBoundary from "./error-boundary";
import {useProcessCheckoutSuccess, useProcessExpressCheckoutError} from "../hooks";

const getData = getSettings('stripe_link_checkout_data');

export default function Block() {
    const {cart} = useSelect(select => {
        const store = select(CART_STORE_KEY);
        return {
            cart: store.getCartData()
        };
    });

    let options = {
        mode: 'payment',
        paymentMethodCreation: 'manual',
        amount: parseInt(cart.totals.total_price),
        currency: cart.totals.currency_code.toLowerCase(),
        payment_method_types: ['card', 'link']
    }

    if (parseInt(cart.totals.total_price) === 0) {
        options = {
            mode: 'setup',
            currency: cart.totals.currency_code.toLowerCase(),
        }
    }

    return (
        <ErrorBoundary>
            <Elements stripe={initStripe} options={options}>
                <LinkComponent cart={cart}/>
            </Elements>
        </ErrorBoundary>
    )
}

const LinkComponent = ({cart}) => {
    const {billingAddress, shippingAddress = {}, activePaymentMethod} = cart;
    const {email, phone} = billingAddress;
    const {phone: shippingPhone = ''} = shippingAddress;
    const linkIcon = getData('linkIcon');
    const launchLink = getData('launchLink');
    const popupEnabled = getData('popupEnabled');

    const {
        onCheckoutFail,
        onCheckoutSuccess
    } = checkoutEvents;

    useProcessCheckoutSuccess({
        gatewayId: 'stripe_cc',
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod: 'stripe_cc',
        emitResponse: {
            responseTypes: {
                ERROR: 'error',
                FAIL: 'failure',
                SUCCESS: 'success'
            },
            noticeContexts: {
                CART: 'wc/cart',
                CHECKOUT: 'wc/checkout',
                PAYMENTS: 'wc/checkout/payments',
                EXPRESS_PAYMENTS: 'wc/checkout/express-payments',
            }
        }
    });

    useLink({
        email,
        phone,
        launchLink,
        popupEnabled,
        shippingPhone,
    });

    useLinkIcon({enabled: linkIcon, icon: linkIcon});

    const options = {
        fields: {
            billingDetails: {address: 'never'}
        },
        wallets: {applePay: 'never', googlePay: 'never'}
    };

    return (
        <div style={{display: 'none'}}>
            <PaymentElement options={options}/>
        </div>
    );
}

registerExpressPaymentMethod({
    name: getData('name'),
    canMakePayment: (props) => {
        // always return false so Link is hidden from express checkout
        return false;
    },
    content: null,
    edit: null,
    supports: {
        showSavedCards: getData('showSavedCards'),
        showSaveOption: getData('showSaveOption'),
        features: getData('features')
    }
})